import { type LbRoom, type Room } from '../waitingRoom.types';

export const transformRoom = (room: LbRoom): Room => ({
  ...room,
  id: room.id.toString(),
});

export const transformRooms = (rooms: LbRoom[]): Room[] => {
  if (rooms.length === 0) {
    return [];
  }

  return rooms.map((room: LbRoom) => transformRoom(room));
};
